import CONSTANTS from './shared/tags.constants'

/**
 * Generates array of meta objects to use in the head section regarding social integration (OpenGraph and Twitter card).
 * @param {*} url FIP page URL
 * @param {*} title Program title
 * @param {*} description Program description (synopsis)
 * @param {*} imageUrl Program cover URL
 * @param {*} imageWidth Program cover width
 * @param {*} imageHeight Program cover width
 * @param wassupUrl
 */
export function generateSocialMetaTags (url, title, description, imageUrl, imageWidth, imageHeight, wassupUrl, type) {
  const openGraphMetaTags = generateOpenGraphMetaTags({ url, title, description, imageUrl, imageWidth, imageHeight, wassupUrl, type })
  const twitterMetaTags = generateTwitterLargeImageCardMetaTags({ title, description, imageUrl, wassupUrl, type })

  return [
    ...openGraphMetaTags,
    ...twitterMetaTags
  ]
}

/**
 * Generate meta objects for OpenGraph
 * @param {*} infos { url, title, description, imageurl, imageWidth, imageHeight }
 */
function generateOpenGraphMetaTags ({ url, title, description, imageUrl, imageWidth, imageHeight, wassupUrl, type }) {
  return [
    { hid: 'og_site_name', property: 'og:site_name', content: CONSTANTS.OPEN_GRAPH.DEFAULT[type || ''].TITLE },
    { hid: 'og_locale', property: 'og:locale', content: CONSTANTS.OPEN_GRAPH.DEFAULT.LOCALE },
    { hid: 'og_type', property: 'og:type', content: CONSTANTS.OPEN_GRAPH.TYPE },
    { hid: 'og_url', property: 'og:url', content: url || '' },
    { hid: 'og_title', property: 'og:title', content: title || CONSTANTS.OPEN_GRAPH.DEFAULT[type || ''].TITLE },
    { hid: 'og_description', property: 'og:description', content: description || CONSTANTS.OPEN_GRAPH.DEFAULT[type].DESCRIPTION || '' },
    { hid: 'fb_app_id', property: 'fb:app_id', content: CONSTANTS.OPEN_GRAPH.FB_APP_ID },
    { hid: 'og_image', property: 'og:image', content: imageUrl || `${ wassupUrl || CONSTANTS.OPEN_GRAPH.DEFAULT[type].BASEURL || '' }${ CONSTANTS.OPEN_GRAPH.DEFAULT.COVER }` },
    { hid: 'og_image_width', property: 'og:image:width', content: imageWidth || CONSTANTS.OPEN_GRAPH.COVER_SIZE[type].WIDE.WIDTH || '' },
    { hid: 'og_image_height', property: 'og:image:height', content: imageHeight || CONSTANTS.OPEN_GRAPH.COVER_SIZE[type].WIDE.HEIGHT || '' }
  ]
}

/**
 * Generate meta objects for Twitter card (only large image card)
 * @param {*} infos { title, description, imageurl }
 */
function generateTwitterLargeImageCardMetaTags ({ title, description, imageUrl, wassupUrl, type }) {
  return [
    { hid: 'twitter_card', name: 'twitter:card', content: CONSTANTS.TWITTER.CARD },
    { hid: 'twitter_site', name: 'twitter:site', content: CONSTANTS.TWITTER.SITE },
    { hid: 'twitter_title', name: 'twitter:title', content: title || CONSTANTS.TWITTER.DEFAULT[type].TITLE || '' },
    { hid: 'twitter_description', name: 'twitter:description', content: description || CONSTANTS.TWITTER.DEFAULT[type].DESCRIPTION || '' },
    { hid: 'twitter_image', name: 'twitter:image', content: imageUrl || `${ wassupUrl || CONSTANTS.TWITTER.DEFAULT[type].BASEURL || '' }${ CONSTANTS.TWITTER.DEFAULT.COVER }` }
  ]
}
